import { useRef } from "react";
import { Editor } from "@tinymce/tinymce-react";

export default function OfficeScheduleEditor({ value, onChange }) {
  const editorRef = useRef(null);

  return (
    <div className="OfficeScheduleEditor">
      <Editor
        tinymceScriptSrc="https://cdnjs.cloudflare.com/ajax/libs/tinymce/6.8.3/tinymce.min.js"
        onInit={(evt, editor) => (editorRef.current = editor)}
        value={value}
        onEditorChange={(content) => onChange(content)}
        init={{
          height: 220,
          menubar: false,
          statusbar: false,
          language: "es",
          plugins: ["lists", "advlist"],
          toolbar: "bullist numlist | bold italic | removeformat",
          content_style: `
            body {
              font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
              font-size: 14px;
              line-height: 1.5;
              color: #2b363d;
              margin: 8px;
            }
            ul, ol { padding-left: 1.25rem; margin: 0.25rem 0; }
            li { margin-bottom: 0.2rem; }
          `,
        }}
      />
    </div>
  );
}
